import React, { useState, useEffect } from "react";
import "./Hero.css";
import secureLocalStorage from "react-secure-storage";

const Hero = () => {
  const [typedText, setTypedText] = useState("");
  const textToType = "Next Generation Forex Trading";
  const typingSpeed = 160; // Adjust typing speed here (in milliseconds)
  const repeatCount = 10000;

  useEffect(() => {
    let currentIndex = -1;
    let currentRepeat = 0;
    let typingInterval;

    const typeText = () => {
      if (currentIndex < textToType.length - 1) {
        setTypedText((prevText) => prevText + textToType[currentIndex]);
        currentIndex++;
      } else {
        if (currentRepeat < repeatCount - 1) {
          currentRepeat++;
          currentIndex = -1;
          setTypedText("");
        } else {
          clearInterval(typingInterval);
        }
      }
    };

    typingInterval = setInterval(typeText, typingSpeed);

    return () => {
      clearInterval(typingInterval);
    };
  }, []);

  const [role, setRole] = useState("");

  useEffect(() => {
    const userRole = secureLocalStorage.getItem("role");
    setRole(userRole);
  }, []);

  return (
    <section id="hero" className="hero">
      <div className="background">
        {/* Use the background image */}
        <div className="background-gif" />
        <img
          className="forex-background-icon"
          alt=""
          src="/forex-background.png"
        />
        <div className="bg" />
        <div className="bg1" />
      </div>

      <div className="hero-content">
        <h1 className="next-generation-forex">{typedText}</h1>
        <h3 className="grow-your-account-container">
          <p className="grow-your-account">
            Grow Your Account with Forex Miner
          </p>
        </h3>
        <button className="join-now">
          {role === "admin" ? (
            <b className="join-now-text">Join Now</b>
          ) : (
            <a href="#packages">
              <b className="join-now-text">Join Now</b>
            </a>
          )}
        </button>
        <div className="we-trade-on">We Trade on</div>
        <div className="currency-pairs">
          <div className="eurusd">
            <div className="circle" />
            <div className="text">EUR/USD</div>
          </div>
          <div className="gbpusd">
            <div className="circle" />
            <div className="text">GBP/USD</div>
          </div>
          <div className="usdjpy">
            <div className="circle" />
            <div className="text">USD/JPY</div>
          </div>
          <div className="audusd">
            <div className="circle" />
            <div className="text">AUD/USD</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
